module.exports = __webpack_public_path__ + "img/103.8.7fceee3b.png";